module.exports = "/images/historical_white.png?43480117279486a5b797cb1e07b6f61c";